<template>
    <span class="keyboard">{{ props.icon }}</span>
</template>
<script setup lang="ts">
type Props = {
    icon: string;
};
const props = defineProps<Props>();
</script>
<style lang="scss" scoped>
.keyboard {
    height: 18px;
    min-width: 24px;
    margin: 0 2px 0 2px;
    padding: 0 4px 0 4px;
    background-color: #f0f0f0;
    color: #232323;
    border-radius: 4px;
    --multiply-color: rgba(0, 0, 0, 0.05);
    background-image: linear-gradient(to bottom, var(--multiply-color), var(--multiply-color));
    background-blend-mode: multiply;
    background-color: inherit;
    min-width: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .icon {
        fill: #333;
        transition: fill 0.3s ease;

        &:hover {
            fill: #007bff;
        }
    }
}
</style>
